import type { CustomerType } from '@/store/types/user'

export const customerTypesElegibleForSubscriptionDiscounts: CustomerType[] = [
  'Associate',
  'Member',
]
